var wishlistOverlay = {

	preInit: function () {
		// get template
		var template = $('#wishlistOverlayTemplate').html();
		template = Hogan.compile(template);

		// add template
		$('.l-usp-bar').after(template.render());

		wishlistOverlay.allow = true;

		var p = $('#popupWishlistOverlay');
		if (!p.length) return;

		// close
		p.find('.js-close').off('click').on('click', function () {
			p.hide();
			return false;
		});

		// init
		var sticky = new Waypoint.Sticky({
			element: p[0]
		});

		// continue
		wishlistOverlay.init();
	},

	init: function () {

		$('.js-add-to-wishlist').each(function () {
			var link = $(this);
			var data = link.closest('form').serialize();
			// click
			link.off('click').on('click', function () {
				wishlistOverlay.update(link, data);
				return false;
			});
		});

	},

	update: function (link, data) {
		var p = $('#popupWishlistOverlay');
		if (!p.length) return;

		var adding = link.attr('data-add') == 'true' ? true : false;

		// disable link
		link.attr('disabled', 'disabled').addClass('loading');

		// ajax
		$.ajax({
			url: adding ? '/favourites/addajax/' : '/favourites/removeajax/',
			type: 'POST',
			data: data,
			success: function (response) {

				if (!response.Success) {
					// show confirm or overlay
					popups.confirm('Favourites', 'Sorry, the product could not be added to your favourites.<br />Please refresh and try again.', '', true);
					return;
				}

				// analytics
				site.analytics.track('Add to wishlist', 'Click', response.DisplayName);

				var message = '<b>{0}</b> was {1} your favourites';
				message = message.replace('{0}', response.DisplayName);

				// adding
				if (adding) {
					// message
					message = message.replace('{1}', 'added to');
					// link text
					link.text('Added to Favourites').attr('data-add', 'false').val('removeFromWishlist').addClass('active');
				}

				// removing
				if (!adding) {
					// message
					message = message.replace('{1}', 'removed from');
					// link text
					link.text('Add to Favourites').attr('data-add', 'true').val('addToWishlist').removeClass('active');
				}

				// update message
				var e = p.find('.js-message');
				e.html(message);

				// pulse if already visible
				if (e.is(':visible')) {
					e.addClass('pulse');
				}

				// clear pulse after ends
				e.one('webkitAnimationEnd oanimationend msAnimationEnd animationend', function () {
					e.removeClass('pulse');
				});

				// show
				wishlistOverlay.show();

				// update basket counts
				$('.js-wishlist-count').html(response.TotalItemQuantity);

				// init
				popups.init();
			},
			error: function (e) {
				// show notice
				popups.confirm('Favourites', 'Sorry, the product could not be added to your favourites (' + e.statusText.toLowerCase() + '). Please try again.', '', true);
			},
			complete: function () {
				// enable
				link.removeAttr('disabled').removeClass('loading');
			}
		});
	},

	show: function () {
		$('#popupWishlistOverlay').show();
	},

	hide: function () {
		$('#popupWishlistOverlay').hide();
	}

};

$(function () {
	wishlistOverlay.preInit();
	site.doc.ajaxComplete(function () {
		wishlistOverlay.init();
	});	
});